import { CellDimension } from "./dashboard-config";

export const isSameCell = (a: CellDimension, b: CellDimension): boolean =>
    a.row === b.row &&
    a.column === b.column &&
    a.width === b.width &&
    a.height === b.height;

export const isColliding = (a: CellDimension, b: CellDimension): boolean =>
    a.column + a.width > b.column &&
    a.column < b.column + b.width &&
    a.row + a.height > b.row &&
    a.row < b.row + b.height;

export const isInside = (inner: CellDimension, outer: CellDimension): boolean =>
    inner.column >= outer.column &&
    inner.row >= outer.row &&
    inner.column + inner.width <= outer.column + outer.width &&
    inner.row + inner.height <= outer.row + outer.height;
